import { useMemo, useState } from "react";
import classes from "./QuestionWiseAnalysis.module.css";
import Search from "./Search";
import Pagination from "./Pagination";
import data from "./data.json";
import { Table } from "react-bootstrap";
import { isEmpty } from "../../utils/custom_funtions";

const QuestionWiseAnalysis = () => {
  const btnType = ["Incorrect", "Unattempted"];
  const [activeTab, setActiveTab] = useState(btnType[0]);
  const [totalItems, setTotalItems] = useState(0);
  const [currentPage, setCurrentPage] = useState(1);
  const [search, setSearch] = useState("");
  const ITEMS_PER_PAGE = 5;
  const commentsData = useMemo(() => {
    let computedComments = data;

    if (search) {
      computedComments = computedComments.filter((comment) =>
        comment.qid.toLowerCase().includes(search.toLowerCase())
      );
    }

    setTotalItems(computedComments.length);
    //Current Page slice
    return computedComments.slice(
      (currentPage - 1) * ITEMS_PER_PAGE,
      (currentPage - 1) * ITEMS_PER_PAGE + ITEMS_PER_PAGE
    );
  }, [data, currentPage, search, ITEMS_PER_PAGE]);

  return (
    <>
      <div className={classes.head}>
        <p className={classes.heading}>Question-wise Analysis</p>
        <Search
          onSearch={(value) => {
            setSearch(value);
            setCurrentPage(1);
          }}
        />
      </div>
      <div className={classes.line}></div>
      <div className="text-center my-2">
        {btnType.map((type) => {
          return (
            <button
              key={type}
              className={`${classes.tab} ${
                activeTab === type ? classes.tabActive : ""
              }`}
              onClick={() => setActiveTab(type)}
            >
              {type}
            </button>
          );
        })}
      </div>
      <div className={classes.section}>
        <Table responsive bordered className={classes.table}>
          <thead className={classes.header}>
            <tr>
              <th>Q. No</th>
              <th>QID</th>
              <th>
                <p>No. Of Students(%)</p>
                <p className={classes.subHeading}>(Answered Incorrect)</p>
              </th>
            </tr>
          </thead>
          <tbody>
            {isEmpty(commentsData) && !isEmpty(search) && (
              <tr>
                <td colSpan={3}>No data found !!</td>
              </tr>
            )}
            {commentsData.map((data, index) => (
              <tr>
                <td>{data.qNo}.</td>
                <td className={classes.qid}>{data.qid}</td>
                <td>{data.noStu}</td>
              </tr>
            ))}
          </tbody>
        </Table>
        <div className="mt-2">
          <Pagination
            total={totalItems}
            itemsPerPage={ITEMS_PER_PAGE}
            currentPage={currentPage}
            onPageChange={(page) => setCurrentPage(page)}
          />
        </div>
      </div>
    </>
  );
};

export default QuestionWiseAnalysis;
